export const INKLE_WEBSITE_URL = "https://www.inkle.ai/";
export const HELLO_EMAIL = "hello@inkle.ai";
export const SUPPORT_EMAIL = "support@inkle.ai";
export const SUPPORT_PHONE_NUMBER = "+1 (256) 403-0863";
export const ADMIN_EMAIL = "admin@inkle.ai";
export const TEAM_ALPHA_EMAIL = "team_alpha@inkle.ai";
export const NO_REPLY_EMAIL = "no-reply@inkle.ai";
export const RECEIPTS_MAIL = "receipts@inkle.ai";
export const SALES_EMAIL = "sales@inkle.ai";
export const CASH_ACCRUAL_BLOG_URL =
  "https://www.inkle.ai/blog/cash-vs-accrual-accounting-101-in-60-seconds";
export const BANK_ACCESS_BLOG_URL =
  "https://www.inkle.ai/help/giving-bank-access-to-team-inkle-as-bookkeeper";
export const INKLE_R_AND_D_PRICING = "https://www.inkle.ai/pricing#Inkle%20R&D";
export const DEFAULT_PAGE_SIZE = 20;
